import { Injectable,EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EnquiryListService {

    constructor(private _http: HttpClient) { }

    getenquiry(data) {
        return this._http.post(environment.api_url+'admin/enquiry/list',data);
    }

}
